export default __webpack_public_path__ + "static/media/Ellipse30Track2.84005f27.svg";